export const getDiaSemana = () => {
  const day = new Date().getDay()
  let dia
  switch (day) {
    case 0:
      dia = 'domingo'
      break
    case 1:
      dia = 'lunes'
      break
    case 2:
      dia = 'martes'
      break
    case 3:
      dia = 'miercoles'
      break
    case 4:
      dia = 'jueves'
      break
    case 5:
      dia = 'viernes'
      break
    case 6:
      dia = 'sabado'
      break
    default:
      dia = 'lunes'
      break
  }
  return dia
}
